import { Plan, resolveSubscriptionPlanPrice, hasRole, type RoleCheckable } from '@court-sync/shared';

/**
 * Whether the Settings page should show the Subscription tab.
 * Platform billing is academy-owner only; owners keep access even when they also
 * hold coach or guardian roles for the same academy.
 */
export function canShowSettingsSubscriptionTab(user: RoleCheckable | null | undefined): boolean {
  if (!user) return false;
  if (hasRole(user, 'admin')) return false;
  if (hasRole(user, 'academy_owner')) return true;
  if (hasRole(user, 'club_owner')) return true;
  if (hasRole(user, 'academy_admin') && !hasRole(user, 'academy_owner')) return false;
  if (hasRole(user, 'guardian') || hasRole(user, 'coach')) return false;
  return false;
}

/**
 * Format card brand string for display.
 */
export function formatCardBrand(brand: string): string {
  const brandMap: Record<string, string> = {
    visa: 'Visa',
    mastercard: 'Mastercard',
    amex: 'American Express',
    discover: 'Discover',
    diners: 'Diners Club',
    jcb: 'JCB',
    unionpay: 'UnionPay',
  };
  return brandMap[brand.toLowerCase()] || brand.charAt(0).toUpperCase() + brand.slice(1);
}

export function getPlanPrice(plan: Plan, userRegion?: string, interval: 'month' | 'year' = 'month'): number {
  const resolved = resolveSubscriptionPlanPrice(plan, { region: userRegion, interval });
  if (resolved) {
    return resolved.amountMajor;
  }
  return plan.price || 0;
}
